import { GridColTypeDef, GridComparatorFn, GridSingleSelectColDef } from "@mui/x-data-grid-pro";
import { toCurrencyFormat } from "./string-utils";
import { allTiers } from "constants/tiers";

export const currencyCol: GridColTypeDef = {
  type: "number",
  valueFormatter: ({ value }) => toCurrencyFormat(value),
};

export const dateCol: GridColTypeDef = {
  type: "date",
  valueGetter: ({ value }) => new Date(value),
};

export const optionalDateCol: GridColTypeDef = {
  type: "date",
  valueGetter: ({ value }) => (value ? new Date(value) : null),
};

export const numberCol = (defaultValue?: number | string | ((val: number) => number | string)): GridColTypeDef => {
  return {
    type: "number",
    valueFormatter: defaultValue != undefined ? ({ value }) => value ?? "N/A" : undefined,
  };
};

export const tierRanking = [
  { tier: "Yaaviatam", ranking: 1 },
  { tier: "Turquoise", ranking: 2 },
  { tier: "Diamond", ranking: 3 },
  { tier: "Amber", ranking: 4 },
  { tier: "Emerald", ranking: 5 },
  { tier: "Classic", ranking: 6 },
  { tier: "Unknown", ranking: 7 },
];

export const tierComparator: GridComparatorFn<string> = (a, b) => {
  const tierA = tierRanking.find((tr) => tr.tier.toLowerCase() === a.toLowerCase())?.ranking ?? 0;
  const tierB = tierRanking.find((tr) => tr.tier.toLowerCase() === b.toLowerCase())?.ranking ?? 0;

  return tierB - tierA;
};

export const tierCol: GridColTypeDef & { valueOptions: string[] } = {
  type: "singleSelect",
  valueOptions: allTiers,
  sortComparator: tierComparator,
};
